import React, { useState } from 'react'

import SanitizedHtml from '@/components/misc/SanitizedHtml'
import { Button } from '@/components/ui/button'

interface CollapsibleListProps {
  items: string[]
  collapseThreshold?: number
}

const CollapsibleList: React.FC<CollapsibleListProps> = ({
  items,
  collapseThreshold = 5,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleOpen = () => {
    setIsOpen(!isOpen)
  }

  const displayItems = isOpen ? items : items.slice(0, collapseThreshold)

  return (
    <>
      <ul className="mb-0 list-none pl-0">
        {displayItems.map((item, index) => (
          <SanitizedHtml key={index} html={item} as="li" />
        ))}
      </ul>

      {items.length > collapseThreshold && (
        <Button
          variant="plain"
          size="sm"
          className="text-dim"
          onClick={toggleOpen}
        >
          {isOpen
            ? 'show fewer'
            : `show ${items.length - collapseThreshold} more`}
        </Button>
      )}
    </>
  )
}

export default CollapsibleList
